module.exports = __webpack_public_path__ + "img/akk001.12611df4.png";